import { render, staticRenderFns } from "./list-souscription.vue?vue&type=template&id=ca886f24&scoped=true"
import script from "./list-souscription.vue?vue&type=script&lang=js"
export * from "./list-souscription.vue?vue&type=script&lang=js"
import style0 from "./list-souscription.vue?vue&type=style&index=0&id=ca886f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca886f24",
  null
  
)

export default component.exports